<script setup>
import { Core as YubinBangoCore } from 'yubinbango-core2';
import {ref} from "vue";
const siteUrl = document.querySelector('meta[name="site-url"]').content;
const props = defineProps({
  isShow: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
    required: true,
  },
  user: {
    type: Object,
    required: true,
  },
  errors: {
    type: Object,
    required: true,
  },
});
const emits = defineEmits(['request-close', 'request-submit', 'update-field', 'request-valid', 'request-back']);

// 自動入力
const autoAddress = () => {
  new YubinBangoCore(props.user.zip, function(addr) {
    emits('update-field', {field: 'address', value: addr.region+addr.locality+addr.street});
  })
};
</script>

<template>
  <div v-if="isShow">
    <div :class="{modModalWindow: true, isShow}">
      <div class="modModalTitleContainer">
        <p class="pFont16 pFontBold">当選時配送先情報</p>
        <button
          type="button"
          class="lyHvCnt lyColumn lyW48px lyH48px pFont10 pFontBold"
          @click="emits('request-close')"
        >
      <span class="lyBlock lyW24px"><img
        :src="siteUrl+'images/iconClose.svg'"
        loading="lazy"
        alt="" width="30"
        height="31"
      ></span>
          とじる
        </button>
      </div>
      <div class="modModalBottomWrapper">
        <div
          v-if=" ! isEdit"
          class="lyPt8 lyPb8 pBackColorWhite pBorderRadius4px"
        >
          <dl>
            <dt class="lyPt4 lyPb4 lyPr16 lyPl16 lyVerticalBwCnt">
              <div class="lyVerticalCntBreak">
                <label
                  for="postalcode"
                  class="lyMr4 pFont12 pFontMedium"
                >郵便番号</label>
              </div>
            </dt>
            <dd class="lyPt4 lyPb4 lyPr16 lyPl16">
              <p
                v-if="'zip' in errors.value"
                class="lyMb8 pFont12 pFontBold pFontRed"
              >{{Array.isArray(errors.value.zip) ? errors.value.zip.join('、') : errors.value.zip}}</p>
              <div class="lyVerticalCnt">
                <div class="lyW100 lyMr8">
                  <div class="pPopFormWrap">
                    <input
                      :value="user.zip"
                      type="number"
                      id="postalcode"
                      class="pPopForm"
                      placeholder=" "
                      required=""
                      @change="emits('update-field', {field: 'zip', value: $event.target.value})"
                    >
                    <p class="pPopFormLabel">半角数字ハイフンなし入力</p>
                  </div>
                </div>
                <button
                  type="button"
                  class="lyShrinkNone lyPt12 lyPb12 lyPr8 lyPl8 pFont14 pFontBlack pBorder1pxSolidBlack pBorderRadius2px"
                  @click="autoAddress"
                >自動入力</button>
              </div>
            </dd>
            <dt class="lyPt4 lyPb4 lyPr16 lyPl16 lyVerticalBwCnt">
              <div class="lyVerticalCnt">
                <label
                  for="userAddress01"
                  class="lyMr8 pFont12 pFontMedium"
                >住所1</label>
              </div>
            </dt>
            <dd class="lyPt4 lyPb4 lyPr16 lyPl16">
              <p
                v-if="'address' in errors.value"
                class="lyMb8 pFont12 pFontBold pFontRed"
              >{{Array.isArray(errors.value.address) ? errors.value.address.join('、') : errors.value.address}}</p>
              <div class="lyW100">
                <div class="pPopFormWrap">
                  <input
                    :value="user.address"
                    type="text"
                    id="userAddress01"
                    class="pPopForm"
                    placeholder=" "
                    required=""
                    @change="emits('update-field', {field: 'address', value: $event.target.value})"
                  >
                  <p class="pPopFormLabel">都道府県市区町村番地</p>
                </div>
              </div>
            </dd>
            <dt class="lyPt4 lyPb4 lyPr16 lyPl16 lyVerticalBwCnt">
              <div class="lyVerticalCnt">
                <label
                  for="userAddress02"
                  class="lyMr8 pFont12 pFontMedium"
                >住所2</label>
              </div>
            </dt>
            <dd class="lyPt4 lyPb4 lyPr16 lyPl16">
              <p
                v-if="'building' in errors.value"
                class="lyMb8 pFont12 pFontBold pFontRed"
              >{{Array.isArray(errors.value.building) ? errors.value.building.join('、') : errors.value.building}}</p>
              <div class="lyW100">
                <div class="pPopFormWrap">
                  <input
                    :value="user.building"
                    type="text"
                    id="userAddress02"
                    class="pPopForm"
                    placeholder=" "
                    required=""
                    @change="emits('update-field', {field: 'building', value: $event.target.value})"
                  >
                  <p class="pPopFormLabel">マンション名、号室</p>
                </div>
              </div>
            </dd>
            <dt class="lyPt4 lyPb4 lyPr16 lyPl16 lyVerticalBwCnt">
              <div class="lyVerticalCnt">
                <label
                  for="userName"
                  class="lyMr8 pFont12 pFontMedium"
                >お名前</label>
              </div>
            </dt>
            <dd class="lyPt4 lyPb4 lyPr16 lyPl16">
              <p
                v-if="'real_name' in errors.value"
                class="lyMb8 pFont12 pFontBold pFontRed"
              >{{Array.isArray(errors.value.real_name) ? errors.value.real_name.join('、') : errors.value.real_name}}</p>
              <div class="lyW100">
                <div class="pPopFormWrap">
                  <input
                    :value="user.real_name"
                    type="text"
                    id="userName"
                    class="pPopForm"
                    placeholder=" "
                    required=""
                    @change="emits('update-field', {field: 'real_name', value: $event.target.value})"
                  >
                  <p class="pPopFormLabel">氏名、フルネーム</p>
                </div>
              </div>
            </dd>
            <dt class="lyPt4 lyPb4 lyPr16 lyPl16 lyVerticalBwCnt">
              <div class="lyVerticalCnt">
                <label
                  for="userAddress02"
                  class="lyMr8 pFont12 pFontMedium"
                >フリガナ</label>
              </div>
            </dt>
            <dd class="lyPt4 lyPb4 lyPr16 lyPl16">
              <p
                v-if="'real_name_kana' in errors.value"
                class="lyMb8 pFont12 pFontBold pFontRed"
              >{{Array.isArray(errors.value.real_name_kana) ? errors.value.real_name_kana.join('、') : errors.value.real_name_kana}}</p>
              <div class="lyW100">
                <div class="pPopFormWrap">
                  <input
                    :value="user.real_name_kana"
                    type="text"
                    id="userNameKana"
                    class="pPopForm"
                    placeholder=" "
                    required=""
                    @change="emits('update-field', {field: 'real_name_kana', value: $event.target.value})"
                  >
                  <p class="pPopFormLabel">カタカナ入力</p>
                </div>
              </div>
            </dd>
            <dt class="lyPt4 lyPb4 lyPr16 lyPl16 lyVerticalBwCnt">
              <div class="lyVerticalCnt">
                <label
                  for="userAddress02"
                  class="lyMr8 pFont12 pFontMedium"
                >電話番号</label>
              </div>
            </dt>
            <dd class="lyPt4 lyPb4 lyPr16 lyPl16">
              <p
                v-if="'tel' in errors.value"
                class="lyMb8 pFont12 pFontBold pFontRed"
              >{{Array.isArray(errors.value.tel) ? errors.value.tel.join('、') : errors.value.tel}}</p>
              <div class="lyW100">
                <div class="pPopFormWrap">
                  <input
                    :value="user.tel"
                    type="number"
                    id="talNumber"
                    class="pPopForm"
                    placeholder=" "
                    required=""
                    @change="emits('update-field', {field: 'tel', value: $event.target.value})"
                  >
                  <p class="pPopFormLabel">半角数字ハイフンなし入力</p>
                </div>
              </div>
            </dd>
          </dl>
          <p
            v-if="'_' in errors.value"
            class="lyMb8 pFont12 pFontBold pFontRed"
          >{{Array.isArray(errors.value._) ? errors.value._.join('、') : errors.value._}}</p>
          <div class="lyPt8 lyPb8 lyPr16 lyPl16">
            <p class="lyW100 lyBlockCnt">
              <button
                type="button"
                class="lyHvCnt lyW100 lyPt12 lyPb12 lyTextCnt pFont14 pFontBold pFontWhite pBackColorGreen pBorderRadius2px pHoverSlideChange"
                @click="emits('request-valid')"
              >こちらの発送先情報で確認</button>
            </p>
          </div>
        </div>
        <div
          v-else
          class="lyPt8 lyPb8 pBackColorWhite pBorderRadius4px"
        >
          <dl>
            <dt class="lyPt4 lyPb4 lyPr16 lyPl16 lyVerticalBwCnt">
              <div class="lyVerticalCnt">
                <p class="lyMr4 pFont12 pFontMedium">郵便番号</p>
              </div>
            </dt>
            <dd class="lyPt4 lyPb4 lyPr16 lyPl16">
              <p class="lyPt12 lyPb12 lyPr8 lyPl8 pFont16 pFontMedium pBackColorGray4 pBorderRadius2px"> {{user.zip}}</p>
            </dd>
            <dt class="lyPt4 lyPb4 lyPr16 lyPl16 lyVerticalBwCnt">
              <div class="lyVerticalCnt">
                <p class="lyMr8 pFont12 pFontMedium">住所1</p>
              </div>
            </dt>
            <dd class="lyPt4 lyPb4 lyPr16 lyPl16">
              <p class="lyPt12 lyPb12 lyPr8 lyPl8 pFont16 pFontMedium pBackColorGray4 pBorderRadius2px">{{user.address}}</p>
            </dd>
            <dt class="lyPt4 lyPb4 lyPr16 lyPl16 lyVerticalBwCnt">
              <div class="lyVerticalCnt">
                <p class="lyMr8 pFont12 pFontMedium">住所2</p>
              </div>
            </dt>
            <dd class="lyPt4 lyPb4 lyPr16 lyPl16">
              <p class="lyPt12 lyPb12 lyPr8 lyPl8 pFont16 pFontMedium pBackColorGray4 pBorderRadius2px">{{user.building}}</p>
            </dd>
            <dt class="lyPt4 lyPb4 lyPr16 lyPl16 lyVerticalBwCnt">
              <div class="lyVerticalCnt">
                <p class="lyMr8 pFont12 pFontMedium">お名前</p>
              </div>
            </dt>
            <dd class="lyPt4 lyPb4 lyPr16 lyPl16">
              <p class="lyPt12 lyPb12 lyPr8 lyPl8 pFont16 pFontMedium pBackColorGray4 pBorderRadius2px">{{user.real_name}}</p>
            </dd>
            <dt class="lyPt4 lyPb4 lyPr16 lyPl16 lyVerticalBwCnt">
              <div class="lyVerticalCnt">
                <p class="lyMr8 pFont12 pFontMedium">フリガナ</p>
              </div>
            </dt>
            <dd class="lyPt4 lyPb4 lyPr16 lyPl16">
              <p class="lyPt12 lyPb12 lyPr8 lyPl8 pFont16 pFontMedium pBackColorGray4 pBorderRadius2px">{{user.real_name_kana}}</p>
            </dd>
            <dt class="lyPt4 lyPb4 lyPr16 lyPl16 lyVerticalBwCnt">
              <div class="lyVerticalCnt">
                <p class="lyMr8 pFont12 pFontMedium">電話番号</p>
              </div>
            </dt>
            <dd class="lyPt4 lyPb4 lyPr16 lyPl16">
              <p class="lyPt12 lyPb12 lyPr8 lyPl8 pFont16 pFontMedium pBackColorGray4 pBorderRadius2px">{{user.tel}}</p>
            </dd>
          </dl>
          <div class="lyHorizontalBwBreak lyFlexItemBreakBan lyTbFlexItemHorizontalRev lyPt8 lyPb8 lyPr16 lyPl16">
            <p class="lyW100 lyTbW50 lyMb16 lyTbMl8 lyTbMb0">
              <button
                type="submit"
                class="lyHvCnt lyW100 lyPt12 lyPb12 lyTextCnt pFont14 pFontBold pFontWhite pBackColorGreen pBorder1pxSolidGreen pBorderRadius2px pHoverSlideChange"
                @click="emits('request-submit')"
              >登録する</button>
            </p>
            <p class="lyW100 lyTbW50 lyTbMr8">
              <button
                type="button"
                class="lyHvCnt lyW100 lyPt12 lyPb12 lyTextCnt pFont14 pFontBold pFontGreen pBorder1pxSolidGreen pBorderRadius2px"
                @click="emits('request-back')"
              >戻って編集</button>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="{gbModalBack: true, mdPopUp: true, isShow}"
      @click="emits('request-close')"
    ></div>
  </div>
</template>
